import React from 'react';
import { Link } from 'react-router-dom';

const ListLinkBoxOption = (props) => {
    return (
        <div className="col s4 m2" style={{ padding: '0.5rem' }}>
            <div className="z-depth-2 box-button" style={{ borderRadius: '8px' }}>
                {
                    props.icon.indexOf('mdi mdi-') >= 0 ? (
                        <Link to={props.route} onClick={props.onClick} style={{ marginTop: '0px' }}>
                            <i className={`${props.icon} f24 text-color`} />
                            <div className="center text-color">{props.text}</div>
                        </Link>
                    ) : (
                        <Link to={props.route} onClick={props.onClick}>
                            <i className="material-icons text-color">{props.icon}</i>
                            <div className="center text-color">{props.text}</div>
                        </Link>
                    )
                }
            </div>
        </div>
        // <div className="z-depth-2 box-button" style={{ borderRadius: '8px', padding: '12px' }}>
        //     <Link
        //         to={props.route}
        //         onClick={props.onClick}
        //         style={{
        //             display: 'flex',
        //             alignItems: 'center',
        //             textDecoration: 'none',
        //             width: '90%',
        //             height: '90%',
        //         }}
        //     >
        //         {
        //             props.icon.indexOf('mdi mdi-') >= 0 ? (
        //                 <i className={`${props.icon} f24 text-color`} style={{ marginRight: '12px' }} />
        //             ) : (
        //                 <i className="material-icons text-color" style={{ marginRight: '12px' }}>{props.icon}</i>
        //             )
        //         }

        //         <div
        //             className="text-color"
        //             style={{
        //                 flex: 1,
        //                 display: 'flex',
        //                 alignItems: 'center',
        //                 justifyContent: 'center',
        //                 height: '100%',
        //             }}
        //         >
        //             {props.text}
        //         </div>
        //     </Link>
        // </div>
    );
};

export default ListLinkBoxOption;
